<template>
  <div id="importar-vacinas">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Importar vacinas"
            description=""
            url="/imunizacao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://esus-feedback.gitbook.io/esus-feedback/imunizacao/importar-vacinas"
            pageIdentifier="importar-vacinas"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-8 mx-auto">
          <div
            class="upload-card border rounded p-4 text-center"
            :class="{ 'border-danger': errorMsg }"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop"
          >
            <input
              ref="fileInput"
              type="file"
              class="d-none"
              accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="onFileChange"
            />
            <div class="mb-3">
              <h5 class="mb-2">Selecione o arquivo .xls ou .xlsx</h5>
              <p class="text-muted mb-0">Arraste e solte aqui ou</p>
            </div>

            <button type="button" class="btn btn-upload" @click="browse">
              Escolher arquivo
            </button>

            <div v-if="file" class="mt-3 small text-muted">
              Arquivo selecionado: <strong>{{ file.name }}</strong>
            </div>

            <div v-if="errorMsg" class="mt-3 text-danger">
              {{ errorMsg }}
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn" :disabled="!file || loading" @click="upload">
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
              />
              Importar XLS
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'ImportarVacinas',
  metaInfo: {
    title: 'Importar vacinas',
    titleTemplate: null,
  },
  components: { Menu, Footer, SectionTitle },
  data() {
    return {
      file: null,
      errorMsg: '',
      loading: false,
      isDragOver: false,
    }
  },
  methods: {
    /**
     * Abre o seletor de arquivos.
     */
    browse() {
      this.$refs.fileInput.click()
    },

    /**
     * Trata a seleção de arquivo pelo input.
     * @param {Event} e Evento de mudança do input
     */
    onFileChange(e) {
      const f = e.target.files?.[0]
      this.validateAndSetFile(f)
      // limpa o input pra permitir re-selecionar o mesmo arquivo depois
      e.target.value = ''
    },

    /**
     * Ativa o estado visual de drag over.
     */
    onDragOver() {
      this.isDragOver = true
    },

    /**
     * Remove o estado visual de drag over.
     */
    onDragLeave() {
      this.isDragOver = false
    },

    /**
     * Trata o arquivo solto na área de upload.
     * @param {DragEvent} e Evento de drop
     */
    onDrop(e) {
      this.isDragOver = false
      const f = e.dataTransfer.files?.[0]
      this.validateAndSetFile(f)
    },

    /**
     * Valida o arquivo selecionado e define no estado.
     * @param {File} f Arquivo selecionado
     */
    validateAndSetFile(f) {
      this.errorMsg = ''
      this.file = null
      if (!f) return

      // validação por extensão
      const isXls = /\.xls$/i.test(f.name)
      const isXlsx = /\.xlsx$/i.test(f.name)

      // validação por MIME
      const allowedMimes = [
        'application/vnd.ms-excel', // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      ]
      const isAllowedMime = allowedMimes.includes(f.type) || f.type === ''

      if (!(isXls || isXlsx) || !isAllowedMime) {
        this.errorMsg = 'Arquivo inválido. Envie um arquivo .xls ou .xlsx.'
        return
      }

      // tamanho opcional (ex.: até 10 MB)
      // const maxSize = 10 * 1024 * 1024
      // if (f.size > maxSize) {
      //   this.errorMsg = 'Arquivo muito grande. Tamanho máximo: 10 MB.'
      //   return
      // }

      this.file = f
    },

    /**
     * Envia o arquivo
     */
    async upload() {
      if (!this.file) return
      this.errorMsg = ''
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('co_ibge', this.$store?.state?.cod_ibge ?? '')

        const url = `/app/utils/imunizacao/importar-vacinas`

        const resp = await this.$api.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (resp?.data?.error) {
          this.errorMsg = resp.data.message || 'Falha ao importar o arquivo.'
        } else {
          this.file = null
          this.$toast.success('Importação concluída com sucesso!', '', {
            position: 'topRight',
          })
        }
      } catch (err) {
        this.errorMsg = 'Erro ao enviar o arquivo. Tente novamente.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
#importar-vacinas {
  .upload-card {
    transition: border-color 0.2s ease, background 0.2s ease;
    background: #fafafa;
  }
  .upload-card:hover,
  .upload-card.dragover {
    background: #f2f6ff;
  }
}
</style>
